"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const moment_1 = __importDefault(require("moment"));
const react_datepicker_1 = __importDefault(require("react-datepicker"));
// eslint-disable-next-line import/no-unassigned-import
require("react-datepicker/dist/react-datepicker.css");
const components_1 = require("./components");
const styles_1 = require("./styles");
const RotaCalendar = (_a) => {
    var { value, onChangeDate, isSelectsRange = false, selectedRange, onChangeRange, dateFormat = "dd/MM/yyyy", disabled = false, minDate, maxDate, minYear = (0, moment_1.default)()
        .subtract(41, "years")
        .year(), maxYear = (0, moment_1.default)()
        .add(10, "years")
        .year() } = _a, props = __rest(_a, ["value", "onChangeDate", "isSelectsRange", "selectedRange", "onChangeRange", "dateFormat", "disabled", "minDate", "maxDate", "minYear", "maxYear"]);
    const CustomHeaderWrapper = (props) => (react_1.default.createElement(components_1.CustomHeader, Object.assign({}, props, { minYear: minYear, maxYear: maxYear })));
    const handleChange = (value) => {
        if (isSelectsRange) {
            onChangeRange && onChangeRange(value);
        }
        else {
            onChangeDate && onChangeDate(value);
        }
    };
    const [startDate, endDate] = selectedRange || [null, null];
    return (react_1.default.createElement(styles_1.StyledCalendar, Object.assign({}, props),
        react_1.default.createElement(react_datepicker_1.default, { customInput: react_1.default.createElement(components_1.CustomInput, { isSelectsRange: isSelectsRange, disabled: disabled, minYear: minYear, maxYear: maxYear }), renderCustomHeader: CustomHeaderWrapper, dateFormat: dateFormat, disabled: disabled, popperPlacement: "bottom", minDate: minDate, maxDate: maxDate, selected: !isSelectsRange ? value : null, onChange: handleChange, selectsRange: isSelectsRange, startDate: startDate, endDate: endDate })));
};
exports.default = RotaCalendar;
